import React from "react";
import { Box, Stepper, Step, StepButton, StepConnector } from "@mui/material";
import { afbeeldingAdres } from '../../../instellingen';

const IMG_URL = afbeeldingAdres;

const SlimConnector = (props) => (
  <StepConnector
    {...props}
    sx={{
      "& .MuiStepConnector-line": {
        borderColor: "rgba(0,0,0,0.15)",
        borderStyle: "dashed",
        borderWidth: 1,
      },
    }}
  />
);

export const FeedbackStepper = ({
  steps,
  activeStep,
  completed,
  feedbackCss,
  companyLogo,
  isSmall,
}) => {
  const progressPct = ((activeStep + 1) / steps.length) * 100;

  return (
    <Box sx={{ width: "100%", maxWidth: 860, mb: 4 }}>
      {/* Progress bar */}
      <Box
        sx={{
          height: 3,
          borderRadius: 99,
          background: "rgba(0,0,0,0.08)",
          mb: 3,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            height: "100%",
            width: `${progressPct}%`,
            borderRadius: 99,
            background: feedbackCss?.feedbackHighlightCircleBgClr || "#f37120",
            transition: "width 0.4s ease",
          }}
        />
      </Box>

      <Stepper
        nonLinear
        activeStep={activeStep}
        connector={<SlimConnector />}
        sx={{ px: 0 }}
      >
        {steps.map((label, idx) => (
          <Step key={idx} completed={completed[idx]}>
            <StepButton
              disabled
              sx={{
                "& .MuiStepLabel-label": {
                  fontWeight: activeStep === idx ? 700 : 400,
                  fontSize: { xs: "12px", sm: "14px" },
                  color:
                    activeStep === idx
                      ? feedbackCss?.feedbackHighlightCircleBgClr || "#f37120"
                      : "#9ca3af",
                  transition: "color 0.3s",
                },
                "& .MuiStepIcon-root": {
                  color:
                    activeStep === idx
                      ? feedbackCss?.feedbackHighlightCircleBgClr || "#f37120"
                      : "#d1d5db",
                  transition: "color 0.3s",
                  "& .MuiStepIcon-text": {
                    fill:
                      activeStep === idx
                        ? feedbackCss?.feedbackHighlightCircleTxtClr || "#fff"
                        : "#6b7280",
                  },
                },
              }}
            >
              {!isSmall && label}
            </StepButton>
          </Step>
        ))}
      </Stepper>

      {companyLogo && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <img
            src={`${IMG_URL}/${companyLogo}`}
            alt="Company Logo"
            style={{
              maxWidth: "160px",
              maxHeight: "80px",
              width: "auto",
              height: "auto",
              objectFit: "contain",
              display: "block",
            }}
          />
        </Box>
      )}
    </Box>
  );
};
